"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ClientInfo {
}
exports.ClientInfo = ClientInfo;
//# sourceMappingURL=ClientInfo.js.map